<div class="container container-wrapper">
  <div class="row justify-content-center">
    <div class="col-12 col-xl-11">
      <div class="row">
        <section class="col-md-12 order-1 order-md-0">
          <router-outlet></router-outlet>
        </section>
    </div>
  </div>
</div>
